import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Strip Trello markdown artifacts: [text](url "smartCard-inline") → text */
export function cleanTrello(s: string | null | undefined): string {
  if (!s) return "";
  return s
    .replace(/\[([^\]]*)\]\([^)]*?"smartCard-inline"\)/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .trim();
}
